import { render, staticRenderFns } from "./ProductJudgement.vue?vue&type=template&id=f745dffe&scoped=true&"
import script from "./ProductJudgement.vue?vue&type=script&lang=ts&"
export * from "./ProductJudgement.vue?vue&type=script&lang=ts&"
import style0 from "./ProductJudgement.vue?vue&type=style&index=0&id=f745dffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f745dffe",
  null
  
)

export default component.exports